module.exports = __webpack_public_path__ + "static/media/show-chart.a4132bea.svg";